export default __webpack_public_path__ + "static/media/automated-email.7d35acba.svg";